import React from 'react';
import ShareRewindSlideBase from './ShareRewindSlideBase';
import { RewindStats } from '../../utils/rewindStats';

interface ShareRewindOverviewSlideProps {
  year: number;
  stats: RewindStats;
}

const ShareRewindOverviewSlide = React.forwardRef<HTMLDivElement, ShareRewindOverviewSlideProps>(
  ({ year, stats }, ref) => {
    return (
      <ShareRewindSlideBase ref={ref} year={year}>
        <div className="flex flex-col h-full">
          {/* Top Section - Title */}
          <div className="flex flex-col items-center justify-center text-center pt-20 pb-8">
            <div className="text-7xl font-bold text-white leading-none mb-4">
              Your {year} Stats
            </div>
          </div>

          {/* Middle Section - Statistics */}
          <div className="flex-1 flex flex-col items-center justify-center space-y-10">
            {/* Cruises */}
            <div className="text-center">
              <div className="text-[10rem] font-bold text-white leading-none mb-4">
                {stats.cruisesCompleted}
              </div>
              <div className="text-5xl text-white/90 font-medium">
                {stats.cruisesCompleted === 1 ? 'Cruise' : 'Cruises'} in {year}
              </div>
            </div>

            {/* Nights at Sea */}
            <div className="text-center">
              <div className="text-[10rem] font-bold text-white leading-none mb-4">
                {stats.nightsAtSea}
              </div>
              <div className="text-5xl text-white/90 font-medium">
                {stats.nightsAtSea === 1 ? 'Night' : 'Nights'} at Sea
              </div>
            </div>

            {/* Ports Visited */}
            <div className="text-center">
              <div className="text-[10rem] font-bold text-white leading-none mb-4">
                {stats.portsVisited}
              </div>
              <div className="text-5xl text-white/90 font-medium">
                {stats.portsVisited === 1 ? 'Port' : 'Ports'} Visited
              </div>
            </div>
          </div>

          {/* Bottom Section - Branding */}
          <div className="flex flex-col items-center text-center pb-12">
            <div className="text-5xl font-bold text-white leading-none mb-2">
              Cruising Along
            </div>
            <div className="text-4xl text-white/90 leading-none">
              Track Your Cruise Adventures
            </div>
          </div>
        </div>
      </ShareRewindSlideBase>
    );
  }
);

ShareRewindOverviewSlide.displayName = 'ShareRewindOverviewSlide';

export default ShareRewindOverviewSlide;

